import React from "react";

export default function AgentRegisterFormHeader({ stageTitle, stepIndex, totalSteps }) {
  return (
    <header className="agent-register-form-header">
      <div className="agent-register-form-header__brand">
        <p className="agent-register-form-header__eyebrow">HotelsRiver Agents</p>
        <h1 className="agent-register-form-header__title">הצטרפות לסוכני HotelsRiver</h1>
        <p className="agent-register-form-header__benefit">
          חיפוש, הצעות מחיר והזמנות במערכת אחת — מוכנים למכור מהר יותר.
        </p>
      </div>
      <div className="agent-register-form-header__meta">
        <span className="agent-register-form-header__pill">פחות מדקה</span>
        {stageTitle ? (
          <span className="agent-register-form-header__step">
            שלב {stepIndex + 1} מתוך {totalSteps}
          </span>
        ) : null}
      </div>
      <ul className="agent-register-trust-inline" aria-label="יתרונות הצטרפות">
        <li>ללא התחייבות</li>
        <li>ניסיון ללא כרטיס</li>
        <li>חיבור מאובטח</li>
      </ul>
    </header>
  );
}
